<template>
  <img v-if="type === 'lupe'" src="../../../../images/viluu/icon/lupe.svg" class="lupe-icon" alt="">
</template>


<script>
export default {
  name: 'SvgIcon',
  components: {},
  props: {
    type: String,
  },
  data() {
    return {};
  },
  computed: {},
  methods: {},
  mounted() {

  }
};
</script>

<style scoped>
.lupe-icon {
  width: 20px;
}
</style>